@if (gameMode === 'double') {
  <div class="mode-card__pig-bg"></div>
}

@if (gameMode === 'wheel') {
  <div class="mode-card__shadow-hover"></div>
  <div class="mode-card__wheel-item"></div>
  <div class="mode-card__shadow"></div>
  <div class="mode-card__coin1"></div>
  <div class="mode-card__coin2"></div>
  <div class="mode-card__coin3"></div>
  <div class="mode-card__coin4"></div>
  <div class="mode-card__bg"></div>
}

<div class="mode-card__head">
  <div class="mode-card__title-wrap">
    <div class="mode-card__title">
      {{ cardTitle }}

      @if (showLink) {
        <i class="icon icon_new icon_arrowRight"></i>
      }
    </div>

    @if (countdown$ | async; as timer) {
      <div class="mode-card__timer timer">
      <span class="timer__days">
        {{ timer.days }} {{ timer.days | i18nPlural:daysPlurals }}
      </span>

        <span>{{ timer.hours }}:</span>
        <span>{{ timer.minutes }}:</span>
        <span>{{ timer.seconds }}</span>
      </div>
    }
    <div class="mode-card__bank-wrap">
    @if (!isSoon && counter) {
      
      <span class="mode-card__bank"
        convertDigits="1.0-0"
        duration="750"
        [convertAnimation]="true"
        [convert]="counter.bank"
      ></span>

        @if (counterType === CounterType.GAMES) {
          <span class="mode-card__number-games">
            {{ counter.count }} {{ counter.count | i18nPlural:gamesPlurals }}
          </span>
        }
      
    }
    @if (badge) {
      <div class="mode-card__badge !hidden sm:!flex">
        {{ badge }}
      </div>
    }
    </div>

    @if (isSoon) {
      <div class="mode-card__soon">
        Soon
      </div>
    }
  </div>
  @if (badge) {
    <div class="mode-card__badge lg:!hidden">
      {{ badge }}
    </div>
  }
</div>

@if (gameMode === 'battleship' && !cardVariation) {
  <div class="mode-card__logo"></div>
<!--  <div class="mode-card__gabe"></div>-->
}

<div class="mode-card__img"></div>

@if (counter && counterType === CounterType.USERS && !cardVariation) {
  <div class="mode-card__players-number">
    <i class="icon icon_users-bold"></i> {{ counter.count }}
  </div>
}